export default function withApiHost() {
    return process.env.REACT_APP_API_HOST ||  process.env.API_HOST || 'http://localhost:3001/api';
}
